import React, {useState} from "react"
import { connect } from "react-redux"

import InputMask from "react-input-mask"

import "styles/components/popup.sass"
import "pages/Styles/ProfileV2.sass"
import "pages/Styles/UIKit_v2.sass"

import {httpClient} from "funcs"
import Popup from "../../components/Popup"
import TextField from "../../components/elements/TextField"
import notifyUser, {notifyAboutError} from "../../methods/notifyUser"
import {validateMany} from "../../validate"


export const BANK_DETAIL_FIELDS = [
  {
    key: "bank_name",
    label: "Название банка",
    mask: "",
  },
  {
    key: "bank_account",
    label: "Расчетный счет",
    mask: "99999999999999999999",
  },
  {
    key: "corr_account",
    label: "Корр/счет",
    mask: "99999999999999999999",
  },
  {
    key: "bic",
    label: "БИК",
    mask: "999999999",
  },
]

function filledBankFields(userSession: any) {
  if (!userSession) return []
  return BANK_DETAIL_FIELDS.filter(({key}) => userSession[key]?.length > 0)
}

function fieldsFromSession(userSession: any) {
  const result: Record<string, string> = {}
  BANK_DETAIL_FIELDS.forEach(({key}) => {
    result[key] = userSession?.[key] ?? ""
  })
  return result
}

function digitsOnly(value: string) {
  return (value ?? "").replace(/\D/g, "")
}

let BankDetailsView: any = function BankDetailsView(props: any) {
  const userSession = props.$store.userSession
  const [popupOpen, setPopupOpen] = useState(false)
  const [saving, setSaving] = useState(false)
  const [form, setForm] = useState<Record<string, string>>({})

  if (!userSession) {
    return null
  }

  const isCustomer = userSession.role === "customer"
  const filled = filledBankFields(userSession)

  if (!isCustomer && filled.length === 0) {
    return null
  }

  function openPopup() {
    setForm(fieldsFromSession(userSession))
    setPopupOpen(true)
  }

  async function save() {
    const payload: Record<string, string> = {
      bank_name: (form.bank_name ?? "").trim(),
      bank_account: digitsOnly(form.bank_account),
      corr_account: digitsOnly(form.corr_account),
      bic: digitsOnly(form.bic),
    }

    const errors = validateMany([
      {required: false, rule: "bankName", entity: payload.bank_name, displayFieldText: "Название банка"},
      {required: false, rule: "ruBankAccount", entity: payload.bank_account, displayFieldText: "Расчетный счет"},
      {required: false, rule: "ruBankCorrAccount", entity: payload.corr_account, displayFieldText: "Корр/счет"},
      {required: false, rule: "ruBic", entity: payload.bic, displayFieldText: "БИК"},
    ])
    if (errors.length) {
      notifyAboutError(props, new Error(errors.join("\n")))
      return
    }

    try {
      setSaving(true)
      await httpClient.patch("/user/self", payload)
      props.$commitToStore({
        userSession: {
          ...userSession,
          ...payload,
        },
      })
      notifyUser(props, "Реквизиты обновлены")
      setPopupOpen(false)
    } catch (err) {
      notifyAboutError(props, err)
    } finally {
      setSaving(false)
    }
  }

  function fieldInput(key: string, label: string, mask: string) {
    if (mask) {
      return (
        <InputMask
          mask={mask}
          placeholder={label}
          value={form[key] ?? ""}
          onChange={({target: {value}}: any) => setForm({...form, [key]: value})}
        >
          <TextField id={key}/>
        </InputMask>
      )
    }
    return (
      <TextField
        id={key}
        placeholder={label}
        value={form[key] ?? ""}
        onChange={({target: {value}}: any) => setForm({...form, [key]: value})}
        variant="outlined"
      />
    )
  }

  return (
    <>
      <div className="profile-section-card ui-kit-v2" style={{marginTop: "15px"}}>
        <div className="profile-section-label">
          {isCustomer ? "Банковские реквизиты:" : "Реквизиты организации:"}
        </div>
        {isCustomer && (
          <div className="profile-section-subtitle">
            Попадут в вашу подпись на договоре: банк, расчётный счёт, корр/счёт и БИК.
          </div>
        )}
        {filled.map(({key, label}) => (
          <div key={key} className="profile-section-field">
            <div className="profile-section-field-label">{label}:</div>
            <div className="profile-section-field-value">{userSession[key]}</div>
          </div>
        ))}
        {isCustomer && (
          <>
            <hr className="profile-section-divider"/>
            <div className="profile-section-row">
              <button
                type="button"
                className="new ui-kit-v2-button action-button primary"
                onClick={openPopup}
              >
                <span className="button-text">
                  {filled.length > 0 ? "Изменить реквизиты" : "Задать реквизиты"}
                </span>
              </button>
            </div>
          </>
        )}
      </div>

      {popupOpen && (
        <Popup onClose={() => setPopupOpen(false)} maxWidth="650px">
          <div className="update-user-fields-v2 ui-kit-v2" style={{width: "100%", textAlign: "left"}}>
            <div className="popup-title">Банковские реквизиты</div>
            {BANK_DETAIL_FIELDS.map(({key, label, mask}) => (
              <div
                key={key}
                className="update-user-fields-field-row"
                style={{display: "flex", flexDirection: "column", gap: "6px", marginTop: "12px"}}
              >
                <div className="update-user-fields-field-label">{label}</div>
                <div className="update-user-fields-field-input" style={{width: "100%", maxWidth: "none"}}>
                  {fieldInput(key, label, mask)}
                </div>
              </div>
            ))}
            <hr className="update-user-fields-divider"/>
            <button
              type="button"
              className="update-user-fields-submit"
              style={{width: "100%", display: "flex"}}
              disabled={saving}
              onClick={save}
            >
              <span className="button-text">{saving ? "Сохраняем…" : "Сохранить"}</span>
            </button>
          </div>
        </Popup>
      )}
    </>
  )
}

BankDetailsView = connect(
    (store) => ({ $store: store }),
    (dispatch) => ({
      $commitToStore: (data: any) => dispatch({ ...data, type: 'S' })
    })
)(BankDetailsView)

export default BankDetailsView
